module.exports = __webpack_public_path__ + "assets/img/new_course_hint.55cd3e1b.png";